import styled from 'styled-components';

export const Wrap = styled.div`
  width: calc(100% - 72px);
  height: calc(100% - 72px);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const SavingWrap = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.palette.global02};
  opacity: 0.8;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ${({ theme }) => theme.textStyles.heading01global03};
`;

export const RenderWrap = styled.div`
  position: absolute;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  z-index: -999999;
`;

export const ViewerWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export default null;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/BrandImageViewer/BrandImageViewer.styled.js